import {createAction} from '@reduxjs/toolkit';

export const setLabStatus = createAction('SET_LAB_STATUS');
